import * as React from 'react';
import type { PropsWithChildren } from 'react';

// While inert is a global attribute and can be applied to any element, it is generally used for sections of content.
type InertableTag = 'div' | 'main' | 'section' | 'nav' | 'aside' | 'header' | 'footer';

type InteractionGuardProps = PropsWithChildren<{
  preventInteraction?: boolean;
  as?: InertableTag;
  className?: string;
}>;

// React <19 doesn't recognise inert as a boolean attribute, so we
// spread an empty-string value which the browser treats as present.
// https://github.com/facebook/react/pull/24730
const InteractionGuard = ({
  preventInteraction = false,
  as: Tag = 'div',
  children,
  className,
}: InteractionGuardProps) => (
  <Tag className={className} {...(preventInteraction ? { inert: '' } : {})}>
    {children}
  </Tag>
);

export default InteractionGuard;
